import { DEFAULT_LANGUAGE, i18nOptions } from '@opti-sea/i18n';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

/** Translations are bundled; English only until the RU/UK translation (Backlog, D53). */
if (!i18next.isInitialized) {
  void i18next.use(initReactI18next).init({ ...i18nOptions(DEFAULT_LANGUAGE), initAsync: false });
}

export { i18next };
